/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React from 'react';
import MedalBadge from './MedalBadge';
import '../styles/CommunityMemberBadge.css';

/**
 * Medal-style verified member badge for NGO and Association members.
 * Award ribbon design: scalloped metallic ring, white center with logo, purple ribbons.
 * Shown when member is bulk-uploaded and auto-verified.
 * @param {string} type - 'ngo' | 'association'
 * @param {boolean} showText - Show badge text below medal (default true)
 * @param {string} size - 'small' | 'medium' | 'large'
 * @param {string} label - Optional custom label text (e.g. "UAN Association Verified")
 */
const CommunityMemberBadge = ({ type, showText = true, size = 'medium', label }) => {
  if (!type || (type !== 'ngo' && type !== 'association')) return null;

  const defaultText = type === 'ngo' ? 'NGO Verified' : 'Association Verified';
  const text = label || defaultText;

  return (
    <span
      className={`community-member-badge community-badge-${type} ${size}`}
      title={text}
    >
      <MedalBadge variant={type} size={size} />
      {showText && <span className="badge-text">{text}</span>}
    </span>
  );
};

export default CommunityMemberBadge;
